import { useState } from 'react';
import { faqs } from '@/mocks/home';

export default function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" className="border-b border-background-200 bg-background-100 py-12 md:py-16">
      <div className="mx-auto max-w-shell px-4 md:px-6">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <div className="flex items-center gap-2">
              <span className="h-5 w-1 rounded-full bg-primary-500" />
              <span className="font-label text-sm tracking-[0.2em] text-primary-700">FAQ</span>
            </div>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">常见问题</h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              关于最新地址、备用域名与打不开的处理，这里是访问者最常问的几个问题。
            </p>
            <div className="mt-5 rounded-lg border border-background-200 bg-background-50 p-4">
              <p className="flex items-center gap-2 text-sm text-foreground-800">
                <i className="ri-time-line text-primary-600" />
                本页更新于 2026-10-10
              </p>
              <p className="mt-2 text-[13px] leading-relaxed text-foreground-600">
                遇到新问题，可先在本页更新短讯中核对线路状态，再尝试备用域名。
              </p>
            </div>
          </div>

          <div className="lg:col-span-8">
            <div className="divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-50">
              {faqs.map((f, i) => {
                const isOpen = open === i;
                return (
                  <div key={f.q}>
                    <button
                      type="button"
                      onClick={() => setOpen(isOpen ? null : i)}
                      className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left transition-colors hover:bg-background-100/70"
                    >
                      <span className="font-heading text-base text-foreground-950 md:text-lg">{f.q}</span>
                      <i
                        className={`shrink-0 text-xl text-primary-600 transition-transform ${
                          isOpen ? 'ri-subtract-line' : 'ri-add-line'
                        }`}
                      />
                    </button>
                    {isOpen && (
                      <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-600">{f.a}</p>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}